import React, { useRef, useLayoutEffect } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const SignupGraph = (props) => {
    const chartRef = useRef(null);

    useLayoutEffect(() => {
        let root = am5.Root.new("chartdivSignup");
        root.setThemes([am5themes_Animated.new(root)]);

        var chart = root.container.children.push(am5xy.XYChart.new(root, {
            panX: false,
            panY: false,
            paddingLeft: 0,
            layout: root.verticalLayout
        }));

        var legend = chart.children.push(
            am5.Legend.new(root, {
                centerX: am5.p50,
                x: am5.p50
            })
        );

        var data = [
            { "month": "Jan", "Jordan": 2.5, "Palestine": 2.5, "Israel": 2.1 },
            { "month": "Feb", "Jordan": 2.6, "Palestine": 2.7, "Israel": 2.2 },
            { "month": "Mar", "Jordan": 2.8, "Palestine": 2.9, "Israel": 2.4 },
            { "month": "Apr", "Jordan": 2.8, "Palestine": 2.9, "Israel": 2.4 },
            { "month": "May", "Jordan": 2.8, "Palestine": 2.9, "Israel": 2.4 },
            { "month": "Jun", "Jordan": 2.8, "Palestine": 2.9, "Israel": 2.4 },
            { "month": "Jul", "Jordan": 2.8, "Palestine": 2.9, "Israel": 2.4 },
            { "month": "Aug", "Jordan": 2.8, "Palestine": 2.9, "Israel": 2.4 },
            { "month": "Sep", "Jordan": 2.8, "Palestine": 2.9, "Israel": 2.4 },
            { "month": "Oct", "Jordan": 2.8, "Palestine": 2.9, "Israel": 2.4 },
            { "month": "Nov", "Jordan": 2.8, "Palestine": 2.9, "Israel": 2.4 },
            { "month": "Dec", "Jordan": 2.8, "Palestine": 2.9, "Israel": 2.4 },
        ];

        var xRenderer = am5xy.AxisRendererX.new(root, {
            minGridDistance: 30,
            startLocation: 0,
            endLocation: 1
        });

        var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
            categoryField: "month",
            renderer: xRenderer,
            tooltip: am5.Tooltip.new(root, {})
        }));

        xAxis.data.setAll(data);

        var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
            renderer: am5xy.AxisRendererY.new(root, {
                strokeOpacity: 0.1
            })
        }));

        function makeSeries(name, fieldName) {
            var series = chart.series.push(am5xy.ColumnSeries.new(root, {
                name: name,
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: fieldName,
                categoryXField: "month"
            }));

            series.columns.template.setAll({
                tooltipText: "{name}, {categoryX}: {valueY}",
                width: am5.percent(90),
                tooltipY: 0,
                strokeOpacity: 0
            });

            series.data.setAll(data);

            series.appear();

            series.bullets.push(function () {
                return am5.Bullet.new(root, {
                    locationY: 0,
                    sprite: am5.Label.new(root, {
                        text: "{valueY}",
                        fill: root.interfaceColors.get("alternativeText"),
                        centerY: 0,
                        centerX: am5.p50,
                        populateText: true
                    })
                });
            });

            legend.data.push(series);
        }

        makeSeries("Jordan", "Jordan");
        makeSeries("Palestine", "Palestine");
        makeSeries("Israel", "Israel");

        chart.appear(1000, 100);
        return () => {
            root.dispose();
        };
    }, []);

    useLayoutEffect(() => {
        if (chartRef.current) {
            chartRef.current.set("paddingRight", props.paddingRight);
        }
    }, [props.paddingRight]);

    return (
        <div id="chartdivSignup" style={{ width: "100%", height: "400px" }}></div>
    );
}

export default SignupGraph;
